import { ResponsiveWidth } from 'components/Css';
import styled from 'styled-components';

interface CodeItemProps {
  variant: 'circle' | 'square';
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  height: 100%;
`;

export const ItemInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-small);

  width: 100%;

  @media (min-width: ${ResponsiveWidth}px) {
    justify-content: center;
  }
`;

export const CodeItem = styled.input<CodeItemProps>`
  width: 16.66%;

  font-size: 24px;
  text-align: center;
  line-height: 50px;
  border-radius: var(--border-radius-secondary);
  border: 1px solid var(--colorBorderBase);
  background-color: white;
  outline: none;

  // Remove spinner dos inputs numéricos
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  // Firefox
  &[type='number'] {
    -moz-appearance: textfield;
  }

  @media (min-width: ${ResponsiveWidth}px) {
    width: 72px;
    height: 64px;
  }
`;

export const SendTextData = styled.p`
  font-size: var(--font-paragraph);
  color: var(--color-text);

  @media (min-width: ${ResponsiveWidth}px) {
    font-size: var(--font-medium);
  }
`;

export const ItemWrapper = styled.div`
  margin-bottom: var(--spacing-regular);
  margin-top: var(--spacing-regular);
`;

export const StrongText = styled.span`
  font-family: var(--font-family-bold);
`;
